<template>
  <div>
    <v-card-text class="custom-card-text">
      <p v-if="header" v-bind="header">{{ header.label }}</p>
    </v-card-text>
    <v-layout row wrap>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-autocomplete
          v-if="loadingCounty !== true"
          v-model="selectedCounty"
          :readonly="readonlymutated"
          :disabled="disabled"
          :rules="requiredRules"
          return-object
          item-value="value"
          :class="refSpecs != null ? 'mt-0 pt-0' : null"
          item-text="label"
          :items="counties"
          label="Alege judetul"
          @change="emitInput"
          @input="getLocalities"
        ></v-autocomplete>
        <v-progress-circular
          v-else
          justify-end
          justify-center
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-autocomplete
          v-if="loadingLocality !== true"
          v-model="selectedLocality"
          :readonly="readonlymutated"
          :disabled="disabled"
          :rules="requiredRules"
          return-object
          item-value="value"
          item-text="label"
          :items="localities"
          label="Alege localitatea"
          :class="refSpecs != null ? 'mt-0 pt-0' : null"
          @change="emitInput"
        ></v-autocomplete>
        <v-progress-circular
          v-else
          justify-end
          justify-center
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-flex>
      <!-- _____________________ TEXT FIELDS ___________________ -->
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          :value="selectedLocality != null ? selectedLocality.superior : ''"
          readonly
          label="Alege comuna"
          :class="refSpecs != null ? 'mt-0 pt-0' : null"
        >
          <!-- begin ref buttons -->
          <v-tooltip
            v-if="refSpecs != null && showMinimumAddress"
            :slot="
              refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
                ? refSpecs.selectBtn.placement
                : 'append'
            "
            color="white grey--text"
            left
          >
            <v-btn
              slot="activator"
              icon
              class="ma-0"
              @click="$emit('refShowList')"
            >
              <v-icon>find_replace</v-icon>
            </v-btn>
            <div class="vjsf-tooltip">
              {{
                refSpecs.selectBtn != null &&
                refSpecs.selectBtn.description != null
                  ? refSpecs.selectBtn.description
                  : 'Select'
              }}
            </div>
          </v-tooltip>
          <v-tooltip
            v-if="refSpecs != null && showMinimumAddress"
            :slot="
              refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
                ? refSpecs.clearBtn.placement
                : 'append'
            "
            color="white grey--text"
            left
          >
            <v-btn
              slot="activator"
              icon
              class="ma-0"
              @click="$emit('refClearSelection')"
            >
              <v-icon>clear</v-icon>
            </v-btn>
            <div class="vjsf-tooltip">
              {{
                refSpecs.clearBtn != null &&
                refSpecs.clearBtn.description != null
                  ? refSpecs.clearBtn.description
                  : 'Clear'
              }}
            </div>
          </v-tooltip>
          <!-- end ref buttons -->
        </v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.strada"
          :rules="streetRules"
          label="Strada"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.numarStrada"
          :rules="numberRules"
          label="Numar"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.codPostal"
          :rules="codPostalRules"
          label="Cod postal"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.bloc"
          :rules="blocRules"
          label="Bloc"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.scara"
          label="Scara"
          :rules="scaraRules"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.etaj"
          :rules="etajRules"
          label="Etaj"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
      <v-flex pr-4 xs12 sm12 md6 lg4 xl4>
        <v-text-field
          v-if="!showMinimumAddress"
          v-model="inputValue.apartament"
          :rules="apartamentRules"
          label="Apartament"
          @input="emitInput"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import myApiInstance from '../../rd-forms/APIService'
import CrudModes from '../CrudModes'

export default {
  name: 'AddressWidget',
  props: {
    value: {
      type: Object,
      required: false,
      default: null
    },
    showMinimumAddress: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    header: {
      type: Object,
      default: null
    },
    layout: {
      type: Object,
      default: function() {
        return {
          'pa-2': true,
          xs8: true,
          sm12: true,
          md6: true,
          lg4: true,
          xl4: true
        }
      }
    },
    refSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      readonlymutated: JSON.parse(this.readonly),
      inputValue: this.value || {},
      counties: [],
      disabled: false,
      localities: [],
      selectedCounty: null,
      selectedLocality: null,
      loadingCounty: false,
      loadingLocality: false,
      streetRules: [
        (value) => {
          const pattern = /([A-Z][a-zA-Z]*)+([a-zA-z]+([ '-][a-zA-Z]+)*)/
          return pattern.test(value) || 'Nume strada incorect.'
        }
      ],
      requiredRules: [(v) => !this.required || !!v || 'Item is required'],
      numberRules: [
        (value) => {
          const pattern = /^(?=.{1,10}$)[0-9]*$/
          return pattern.test(value) || 'Numar adresa incorect.'
        }
      ],
      codPostalRules: [
        (value) => {
          const pattern = /^(?=.{6}$)[0-9]*$/
          return pattern.test(value) || 'Cod postal incorect.'
        }
      ],
      blocRules: [
        (value) => {
          const pattern = /^(?=.{0,40}$)([0-9]|[a-zA-Z])*$/
          return pattern.test(value) || 'Numar bloc incorect.'
        }
      ],
      scaraRules: [
        (value) => {
          const pattern = /^(?=.{0,10}$)([a-zA-Z]|[0-9])*$/
          return pattern.test(value) || 'Numar scara incorect.'
        }
      ],
      etajRules: [
        (value) => {
          const pattern = /^(?=.{0,40}$)([a-zA-Z]|[0-9])*$/
          return pattern.test(value) || 'Etaj incorect.'
        }
      ],
      apartamentRules: [
        (value) => {
          const pattern = /^(?=.{0,10}$)([a-zA-Z]|[0-9])*$/
          return pattern.test(value) || 'Numar apartament incorect.'
        }
      ]
    }
  },
  computed: {
    opMode: function() {
      return this.readOnlyMode || this.refMode
        ? CrudModes.TYPES.READ
        : this.entryId != null
        ? CrudModes.TYPES.UPDATE
        : CrudModes.TYPES.ADD
    },
    customInputValue() {
      if (this.showMinimumAddress === true) {
        return {
          _countyId:
            this.selectedCounty != null ? this.selectedCounty.value : null,
          _localityId:
            this.selectedLocality != null ? this.selectedLocality.value : null
        }
      } else {
        return {
          _countyId:
            this.selectedCounty != null ? this.selectedCounty.value : null,
          _localityId:
            this.selectedLocality != null ? this.selectedLocality.value : null,
          strada: this.inputValue.strada,
          numarStrada: this.inputValue.numarStrada,
          codPostal: this.inputValue.codPostal,
          bloc: this.inputValue.bloc,
          scara: this.inputValue.scara,
          etaj: this.inputValue.etaj,
          apartament: this.inputValue.apartament
        }
      }
    }
  },

  created: function() {
    if (this.inputValue !== null && this.opMode !== 'add') {
      this.readonlymutated = true
    }
    this.getJudet()
    //this.getLocalities();
    if (this.inputValue !== null) {
      //console.log("INITIAL VALUE " + JSON.stringify(this.initialValue));
      myApiInstance.getJudetApi().then((res) => {
        this.counties = res
        for (let x in this.counties) {
          if (this.counties[x].value === this.inputValue._countyId) {
            this.selectedCounty = this.counties[x]
            //this.readonlymutated = true;
          }
        }
      })
      if (this.inputValue._countyId != null) {
        myApiInstance
          .getLocalitateApi(this.inputValue._countyId)
          .then((data) => {
            this.localities = data
            for (let y in this.localities) {
              if (this.localities[y].value === this.inputValue._localityId) {
                this.selectedLocality = this.localities[y]
                //this.readonlymutated = true;
              }
            }
          })
      }
    }
  },
  methods: {
    dynamicSort(property) {
      var sortOrder = 1
      if (property[0] === '-') {
        sortOrder = -1
        property = property.substr(1)
      }
      return function(a, b) {
        var result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
        return result * sortOrder
      }
    },
    getJudet() {
      this.loadingCounty = true
      myApiInstance.getJudetApi().then((data) => {
        this.counties = data
        this.loadingCounty = false
        this.counties.sort(this.dynamicSort('label'))
      })
    },
    getLocalities() {
      this.loadingLocality = true
      this.selectedLocality = null
      if (this.selectedCounty == null) return
      myApiInstance.getLocalitateApi(this.selectedCounty.value).then((data) => {
        this.loadingLocality = false
        this.localities = data
        this.localities.sort(this.dynamicSort('label'))
      })
    },
    emitInput: function() {
      this.$emit('input', this.customInputValue)
    }
  }
}
</script>

<style>
.custom-card {
  outline-color: grey;
  outline-offset: 0px;
  padding-left: 10px;
  padding-bottom: 10px;
  margin-bottom: 15px;
  margin-top: 5px;
}
.custom-card-text {
  margin-left: -10px;
  margin-bottom: -30px;
}
</style>
